import { render, staticRenderFns } from "./tutor-selection.vue?vue&type=template&id=35ea43de&scoped=true&"
import script from "./tutor-selection.vue?vue&type=script&lang=js&"
export * from "./tutor-selection.vue?vue&type=script&lang=js&"
import style0 from "./tutor-selection.vue?vue&type=style&index=0&id=35ea43de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ea43de",
  null
  
)

export default component.exports